import * as React from 'react';

import { ContentWrapperLink } from './ContentWrapperLink';
import styles from './ObjectsLayout.css';
import { PriceDisclaimerContainer } from '../../../containers/PriceDisclaimerContainer';
import { NEW_OBJECTS_NAMES, NEW_OBJECTS_KEYS } from '../../../interfaces/village';
import { INewobjectCategorySchema } from '../../../types';
import { rangePrice, getAreaBlock, isArrayWithItems } from '../../../utils/helpers';
import { Card } from '../card';

export interface IObjectOfKP {
  key: string;
  object: INewobjectCategorySchema;
  count: number;
}
export interface IObjectsLayoutProps {
  objects: IObjectOfKP[];
  total: number;
  totalPriceMin?: number;
  totalPriceMax?: number;
  totalOnSaleUrl?: string;
  isCroppedCard?: boolean;
}

export const ObjectsLayout: React.FC<IObjectsLayoutProps> = ({
  objects,
  total,
  totalOnSaleUrl,
  totalPriceMax,
  totalPriceMin,
  isCroppedCard,
}) => {
  if (!isArrayWithItems(objects) && total === 0) {
    return null;
  }

  const hasTotalPriceMin = totalPriceMin !== undefined && totalPriceMin > 0;
  const hasTotalPriceMax = totalPriceMax !== undefined && totalPriceMax > 0;

  return (
    <>
      <Card joinBottom className={styles['top_card']}>
        <div>
          <h2 className={styles['title']}>Объекты в посёлке</h2>
          <PriceDisclaimerContainer size="20" mediaType="mobile" />
        </div>
      </Card>
      {objects.map(({ key, object, count }, index) => {
        const { areaMin, areaMax, priceMin, priceMax, seo } = object;
        const url = count ? seo && seo.url : undefined;

        return (
          <Card
            key={key}
            joinTop
            joinBottom={total > 0 ? true : index + 1 !== objects.length}
            className={styles['sub_card']}
          >
            <ContentWrapperLink url={url}>
              <div className={styles['object_header']}>
                {areaMin && areaMax && (
                  <span className={styles['object_title']}>
                    {NEW_OBJECTS_NAMES[key]}{' '}
                    {getAreaBlock(Math.trunc(areaMin), Math.trunc(areaMax), key === NEW_OBJECTS_KEYS.LANDPLOT)}
                  </span>
                )}
                {count > 0 && <span className={styles['count']}>{count}</span>}
              </div>
              {!isCroppedCard && <div className={styles['object_price']}>{rangePrice(priceMin, priceMax)}</div>}
            </ContentWrapperLink>
          </Card>
        );
      })}
      {total > 0 && totalOnSaleUrl && totalOnSaleUrl !== '' && (
        <Card key={'totalOnSale'} joinTop joinBottom={false} className={styles['sub_card']}>
          <ContentWrapperLink url={totalOnSaleUrl}>
            <div className={styles['object_header']}>
              <span className={styles['object_title']}>Все предложения</span>
              <span className={styles['count']}>{total}</span>
            </div>
            {!isCroppedCard && hasTotalPriceMin && hasTotalPriceMax && (
              <div className={styles['object_price']}>{rangePrice(totalPriceMin, totalPriceMax)}</div>
            )}
          </ContentWrapperLink>
        </Card>
      )}
    </>
  );
};
